import { render, staticRenderFns } from "./explore-block.vue?vue&type=template&id=367d85ed&"
import script from "./explore-block.vue?vue&type=script&lang=js&"
export * from "./explore-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default})
